import {
  FETCH_REQUESTED,
  FETCH_COMPLETED,
  DISPLAY_MESSAGE,
  HIDE_MESSAGE,
} from '../constants/Ui';

export const fetchRequested = () => {
  return {
    type: FETCH_REQUESTED,
  };
};

export const fetchCompleted = () => {
  return {
    type: FETCH_COMPLETED,
  };
};

export const displayMessage = (message) => {
  return {
    type: DISPLAY_MESSAGE,
    message,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
